module.exports = __webpack_public_path__ + "assets/img/24_1067_big.a7f3e658.jpg";